<div class="banner" role="banner">
  <h1>{{ 'trainingzone.page.title' | translate }}</h1>
</div>

<fgb-worksheet-list></fgb-worksheet-list>
